import { sizeByGrade } from '../../../constant/size-by-grade';

export const getCaravanSizeByGrade = (name?: string) => name && sizeByGrade[name]?.size;
